import { FormControl } from "@angular/forms";
import { ytKontrolaPoModulu11 } from "./yt-kontrola-po-modulu-11";

export function YtKontrolaJmbg (control:FormControl){
    let jmbg: string;
    jmbg = control.value;

    if (jmbg == null || jmbg == "")
        return null;
    
    if (jmbg.length != 13)
        return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.LENGTH'};
    
    let nizJmbg = Object.assign([],jmbg);

    for (let i: number =0; i<jmbg.length; i++){
        if (/^\d+$/.test(nizJmbg[i]) == false)
            return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DIGIT'}
    }

    let dan: number = parseInt(jmbg.substr(0,2));
    let mesec: number = parseInt(jmbg.substr(2,2));
    let godina: number = parseInt(jmbg.substr(4,3));

    if (dan < 1)
        return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DAN'}

    switch(mesec){
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            if (dan > 31)
                return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DAN31'};
            break;
        case 4:
        case 6: 
        case 9:
        case 11:
            if (dan > 31)
                return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DAN30'}
            break;
        case 2:
            if ((godina % 4 == 0 && dan > 29) || (godina % 4 != 0 && dan > 28))
                return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DAN28-29'}
            break;
        default:
            break;
    }

    if ((godina > parseInt(new Date().getFullYear.toString().substr(1,3))) && (godina < 899))
        return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.DAN28-29'}
    
    let kontrolniBroj: string;
    kontrolniBroj = ytKontrolaPoModulu11(jmbg.substr(0,12), "jmbg");

    if (kontrolniBroj !== jmbg.substr(12,1))
        return {'jmbgControl' : 'FW.KONTROLAJMBG.VALIDATION.MODUL11'}
    
}